import { Component } from '@verndale/core';

class ExternalLinksModal extends Component {
  internalUrls: string[];
  redirectUrl: string | null;

  constructor(el: HTMLDialogElement) {
    super(el);
    this.internalUrls = el.dataset.internalUrls?.split(',') as string[];
    this.redirectUrl = null;
  }

  setupDefaults() {
    this.dom = {
      closeButton: this.el.querySelector<HTMLElement>('.external-links-modal__close-button'),
      continueButton: this.el.querySelector<HTMLElement>('.external-links-modal__continue'),
    };

    const isPreview = this.el.closest('.storybook-preview');
    if (isPreview) {
      this.open();
    }
  }

  addListeners() {
    document.addEventListener('click', this.handleLinkClick.bind(this));
    (this.dom.closeButton as HTMLElement).addEventListener('click', this.handleCloseClick.bind(this));
    (this.dom.continueButton as HTMLElement).addEventListener('click', this.handleContinueClick.bind(this));
  }

  handleLinkClick(event: MouseEvent) {
    const target = (event.target as HTMLElement).closest('a');
    
    if (target?.classList.contains('external-links-modal__optional-link')) {
      return;
    }
    
    if (target && target.tagName === 'A' && target.href) {
      const isInternal = this.internalUrls.some((url) => target.href.includes(url));
      if (!isInternal) {
        event.preventDefault();
        this.redirectUrl = target.href;
        this.open();
      }
    }
  }

  handleContinueClick() {
    if (this.redirectUrl) {
      window.open(this.redirectUrl, '_blank');
    }
  }

  handleCloseClick() {
    this.close();
  }

  open() {
    (this.el as HTMLDialogElement).showModal();
  }

  close() {
    (this.el as HTMLDialogElement).close();
  }
}

export default ExternalLinksModal;